import { render, staticRenderFns } from "./ProductCheckbox.vue?vue&type=template&id=42bdc15d&scoped=true&lang=pug&"
import script from "./ProductCheckbox.vue?vue&type=script&lang=js&"
export * from "./ProductCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ProductCheckbox.vue?vue&type=style&index=0&id=42bdc15d&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bdc15d",
  null
  
)

export default component.exports